module.exports = __webpack_public_path__ + "img/accept_icon.68f7c6b5.svg";